import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../admin/AuthContext';
import DeliveryAddressModal from '../../components/DeliveryAddressModal';
import '../css/MyPage.css';

const MyPageContent = () => {
    const navigate = useNavigate();
    const { user, loading, isAuthenticated } = useAuth();
    const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);

    // 로그인하지 않은 사용자는 홈으로 리다이렉트
    useEffect(() => {
        if (!loading && !isAuthenticated()) {
            navigate('/');
        }
    }, [loading, isAuthenticated, navigate]);

    // 로딩 중이거나 사용자 정보가 없으면 로딩 표시
    if (loading || !user) {
        return (
            <div className="my-page">
                <div className="uip-breadcrumb">
                    <span>홈</span> &gt; <span>내 정보</span> &gt; <span className="current">My 페이지</span>
                </div>
                <div className="mp-header">
                    <h1 className="mp-title">로딩 중...</h1>
                </div>
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div>사용자 정보를 불러오는 중입니다...</div>
                </div>
            </div>
        );
    }

    // 회사 정보 (실제 데이터베이스 값 사용)
    const companyInfo = {
        name: user.company || '미입력',
        ceo: user.ceoName || '미입력',
        postalCode: user.zipCode || '미입력',
        address: user.address || '미입력',
        addressDetail: user.addressDetail || '미입력',
        businessNumber: user.businessNumber || '미입력',
    };

    // 사용자 정보 (실제 데이터베이스 값 사용)
    const userInfo = {
        manager: user.name || '미입력',
        phone: user.phone || '미입력',
        mobile: user.mobile || '미입력',
        fax: user.fax || '미입력',
        department: user.department || '미입력',
        email: user.email || '미입력',
        loginId: user.email || '미입력'
    };

    const handleEdit = () => {
        navigate('/my-page/edit');
    };

    const handleDeliveryManage = () => {
        setIsDeliveryModalOpen(true);
    };

    const handleCloseDeliveryModal = () => {
        setIsDeliveryModalOpen(false);
    };

    return (
        <div className="my-page">
            <div className="uip-breadcrumb">
                <span>홈</span> &gt; <span>내 정보</span> &gt; <span className="current">My 페이지</span>
            </div>
            <div className="mp-header">
                <h1 className="mp-title">{user.name} 님</h1>
                <p className="mp-customer-code">고객코드 {user.id.toString().padStart(5, '0')}</p>
            </div>

            <div className="mp-info-section">
                <div className="mp-section-header">
                    <h2>회사 정보</h2>
                    <p>회사 정보 변경은 고객센터 이메일로 재증빙해 주세요.</p>
                </div>
                <div className="mp-info-grid">
                    <div className="mp-info-row"><span className="label">회사명</span><span>{companyInfo.name}</span></div>
                    <div className="mp-info-row"><span className="label">대표자명</span><span>{companyInfo.ceo}</span></div>
                    <div className="mp-info-row"><span className="label">우편번호</span><span>{companyInfo.postalCode}</span></div>
                    <div className="mp-info-row"><span className="label">기본 주소</span><span>{companyInfo.address}</span></div>
                    <div className="mp-info-row"><span className="label">상세 주소</span><span>{companyInfo.addressDetail}</span></div>
                    <div className="mp-info-row"><span className="label">사업자 등록번호</span><span>{companyInfo.businessNumber}</span></div>
                    <div className="mp-info-row">
                        <span className="label">배송지 정보</span>
                        <button className="mp-manage-btn" onClick={handleDeliveryManage}>배송지 관리</button>
                    </div>
                </div>
            </div>

            <div className="mp-info-section">
                <div className="mp-section-header">
                    <h2>사용자 정보</h2>
                    <button onClick={handleEdit} className="mp-edit-btn">수정</button>
                </div>
                <div className="mp-info-grid">
                    <div className="mp-info-row"><span className="label">담당자명</span><span>{userInfo.manager}</span></div>
                    <div className="mp-info-row"><span className="label">전화번호</span><span>{userInfo.phone}</span></div>
                    <div className="mp-info-row"><span className="label">휴대폰번호</span><span>{userInfo.mobile}</span></div>
                    <div className="mp-info-row"><span className="label">팩스번호</span><span>{userInfo.fax}</span></div>
                    <div className="mp-info-row"><span className="label">부서</span><span>{userInfo.department}</span></div>
                    <div className="mp-info-row"><span className="label">이메일</span><span>{userInfo.email}</span></div>
                    <div className="mp-info-row"><span className="label">아이디</span><span>{userInfo.loginId}</span></div>
                </div>
            </div>

            {/* 가입 정보 추가 표시 */}
            <div className="mp-info-section">
                <div className="mp-section-header">
                    <h2>가입 정보</h2>
                </div>
                <div className="mp-info-grid">
                    <div className="mp-info-row">
                        <span className="label">가입일</span>
                        <span>{new Date(user.createdAt).toLocaleDateString('ko-KR')}</span>
                    </div>
                    <div className="mp-info-row">
                        <span className="label">최종 로그인</span>
                        <span>
                            {user.lastLoginAt 
                                ? new Date(user.lastLoginAt).toLocaleDateString('ko-KR') + ' ' + 
                                  new Date(user.lastLoginAt).toLocaleTimeString('ko-KR')
                                : '미기록'
                            }
                        </span>
                    </div>
                    <div className="mp-info-row">
                        <span className="label">계정 상태</span>
                        <span style={{ color: user.isActive ? '#28a745' : '#dc3545' }}>
                            {user.isActive ? '활성' : '비활성'}
                        </span>
                    </div>
                </div>
            </div>

            {/* 배송지 관리 모달 */}
            <DeliveryAddressModal 
                isOpen={isDeliveryModalOpen} 
                onClose={handleCloseDeliveryModal} 
            />
        </div>
    );
};

const MyPage = () => {
    return (
        <MyPageContent />
    );
}

export default MyPage; 